import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswSupportCasesState {
}

export default {
  state : {},
  actions: {
    getSerialNumber(context: ActionContext<MswSupportCasesState, RootStoreState>, serialNo: any) { // tslint:disable-line
      // context.commit('startLoading', null, { root: true });
      const url = `support/get-serialnumber-entitlement?serialnumber=${serialNo}`;
      return ApiServiceWrapper.get(url);
    },
    fetchEndUserOrganizations(context: ActionContext<MswSupportCasesState, RootStoreState>) { // tslint:disable-line
      const url = 'support/get-premiersupportorgs';
      return ApiServiceWrapper.get(url);
    },
    getSupportRecord(context: ActionContext<MswSupportCasesState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const url = 'support/view-case/';
      return ApiServiceWrapper.get(url);
    },
    getSupportCase(context: ActionContext<MswSupportCasesState, RootStoreState>, caseId: any) { // tslint:disable-line
      // context.commit('startLoading', null, { root: true });
      const url = `support/get-support-case?caseid=${caseId}`;
      return ApiServiceWrapper.get(url);
    },
    addCaseComment(context: ActionContext<MswSupportCasesState, RootStoreState>, requestBody: any) { // tslint:disable-line
      // context.commit('startLoading', null, { root: true });
      const url = 'support/add-support-note';
      return ApiServiceWrapper.post(url, requestBody);
    },
    caseClose(context: ActionContext<MswSupportCasesState, RootStoreState>, requestBody: any) { // tslint:disable-line
      // context.commit('startLoading', null, { root: true });
      const url = 'support/close-case';
      return ApiServiceWrapper.post(url, requestBody);
    },
    createCase(context: ActionContext<MswSupportCasesState, RootStoreState>, requestBody: any) {
      context.commit('startLoading', null, { root: true });
      const url = 'support/create-case';
      return ApiServiceWrapper.post(url, requestBody);
    },
    uploadSupportAttachment(context: ActionContext<MswSupportCasesState, RootStoreState>, requestBody: any) {
      context.commit('startLoading', null, { root: true });
      const url = 'support/upload-support-attachment-details';
      return ApiServiceWrapper.post(url, requestBody);
    },
    getChatDetails(context: ActionContext<MswSupportCasesState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const url = 'support/get-chat-details';
      return ApiServiceWrapper.get(url);
    },
    getCSCScodeForWebChat(context: ActionContext<MswSupportCasesState, RootStoreState>, requestBody: any) {
      context.commit('startLoading', null, { root: true });
      const url = 'generate-cscaccesscode';
      return ApiServiceWrapper.post(url, requestBody);
    },
  },
  namespaced: true,
} as Module<MswSupportCasesState, RootStoreState>;
